import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import Typography from "../Typography";
import { CaretDown } from "@phosphor-icons/react";
import { CreateEmissionsSourceFormValues } from "./FormValues";
import { EmissionsSourceItems, Portfolio, Sector } from "../../api/models/EmissionsSource";
import { Location } from "../../api/models/Location";
import PreviousSelectionsText from "./PreviousSelectionsText";
import PreviousSelectionSection from "./PreviousSelectionSection";
import { useState } from "react";

type PreviousSelectionsBoxProps = {
    formData: CreateEmissionsSourceFormValues;
    selectedIndex: number;
    locations: Location[];
    emissionsSourceItems: EmissionsSourceItems | null;
    sectors: Sector[];
    portfolios: Portfolio[];
};

const PreviousSelectionsBox = ({
    formData,
    selectedIndex,
    locations,
    emissionsSourceItems,
    sectors,
    portfolios
}: PreviousSelectionsBoxProps) => {
    const [expandPreviousSelection, setExpandPreviousSelection] =
        useState(false);

    const itemsForSelectedType =
        emissionsSourceItems?.emissionsSourceItems.filter(
            (_) => _.typeId === formData.typeId
        ) ?? [];

    const typesForSelectedCategory =
        emissionsSourceItems?.emissionsSourceTypes.filter(
            (_) => _.categoryId === formData.categoryId
        ) ?? [];

    const selectedLocationName =
        locations.find((location) => location.id === formData.locationId)
            ?.name ?? "";
    const selectedItemName =
        emissionsSourceItems?.emissionsSourceItems.find(
            (item) => item.id === formData.itemId
        )?.name ?? "";
    const selectedTypeName =
        emissionsSourceItems?.emissionsSourceTypes.find(
            (type) => type.id === formData.typeId
        )?.name ?? "";
    const selectedCategoryName =
        emissionsSourceItems?.emissionsSourceCategories.find(
            (category) => category.id === formData.categoryId
        )?.name ?? "";

    const selectedPortfolioName = 
        portfolios.find(portfolio => portfolio.id === formData.portfolioId)?.name ?? "";
    
    const selectedSectorName = 
        sectors.find(sector => sector.id === formData.sectorId)?.name ?? "";

    return (
        <Accordion
            expanded={expandPreviousSelection}
            onChange={() =>
                setExpandPreviousSelection(!expandPreviousSelection)
            }
            sx={{ bgcolor: "#19424B", borderRadius: "0.75rem !important" }}
        >
            <AccordionSummary expandIcon={<CaretDown color="white" />}>
                <Typography
                    variant="title-large"
                    component="h1"
                    className="text-white"
                >
                    Previous selections
                </Typography>
            </AccordionSummary>
            <AccordionDetails className="bg-surface-light-1 rounded-b-xl justify-between">
                <PreviousSelectionSection sectionTitle="Profile">
                    <PreviousSelectionsText
                        label="Name:"
                        value={formData.name}
                    />
                    <PreviousSelectionsText
                        label="Unique Reference:"
                        value={formData.uniqueReference}
                    />
                    <PreviousSelectionsText
                        label="Location:"
                        value={selectedLocationName}
                    />
                    <PreviousSelectionsText 
                        label="Portfolio:"
                        value={selectedPortfolioName}
                    />
                    <PreviousSelectionsText 
                        label="Sector:"
                        value={selectedSectorName}
                    />
                </PreviousSelectionSection>
                {selectedIndex > 1 && (
                    <PreviousSelectionSection sectionTitle="Attribution">
                        <PreviousSelectionsText
                            label="Category:"
                            value={selectedCategoryName}
                        />
                        {typesForSelectedCategory.length > 1 && (
                            <PreviousSelectionsText
                                label="Type:"
                                value={selectedTypeName}
                            />
                        )}
                        {itemsForSelectedType.length > 1 && (
                            <PreviousSelectionsText
                                label="Item:"
                                value={selectedItemName}
                            />
                        )}
                        <PreviousSelectionsText 
                            label="Enterprise Value"
                            value={formData.enterpriseValue.toString()}
                        />
                        <PreviousSelectionsText 
                            label="Outstanding Amount"
                            value={formData.outstandingAmount.toString()}
                        />
                    </PreviousSelectionSection>
                )}
            </AccordionDetails>
        </Accordion>
    );
};

export default PreviousSelectionsBox;
